import { useEffect, useRef } from "react";
import { formatDateLong } from "../../../utils/time";
import type { BookingSubmissionResult } from "../../../utils/apiClient";
import styles from "../BookingFlow.module.css";

export function StepConfirmation({ confirmation }: { confirmation: BookingSubmissionResult }) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  const timesLabel = `${confirmation.startTime} - ${confirmation.endTime}${
    confirmation.endNextDay ? " (volgende dag)" : ""
  }`;

  return (
    <section aria-labelledby="dmm-step-confirmation-heading">
      <h2
        id="dmm-step-confirmation-heading"
        ref={headingRef}
        tabIndex={-1}
        className={styles.stepHeading}
      >
        Say Cheese! Jouw aanvraag is binnen.
      </h2>
      <p className={styles.stepIntro}>
        Bedankt voor je aanvraag. We controleren de beschikbaarheid en nemen zo snel mogelijk
        contact met je op via het opgegeven e-mailadres.
      </p>

      <div className={styles.confirmationCard}>
        <p className={styles.confirmationNotice}>
          Let op: je datum is pas definitief gereserveerd nadat je van ons een bevestiging per
          e-mail hebt ontvangen.
        </p>

        <table className={styles.summaryTable}>
          <tbody>
            <tr>
              <th scope="row">Aanvraagnummer</th>
              <td>{confirmation.publicReference}</td>
            </tr>
            <tr>
              <th scope="row">Datum</th>
              <td>{formatDateLong(confirmation.eventDate)}</td>
            </tr>
            <tr>
              <th scope="row">Tijden</th>
              <td>{timesLabel}</td>
            </tr>
            <tr>
              <th scope="row">Locatie</th>
              <td>{confirmation.location}</td>
            </tr>
            <tr>
              <th scope="row">Type evenement</th>
              <td>{confirmation.eventTypeLabel}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}
